/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CouponCommon_Models_DTO_Responses_GetAllCouponsResponseDTO } from '../models/CouponCommon_Models_DTO_Responses_GetAllCouponsResponseDTO';
import type { CouponCommon_Models_DTO_Responses_GetCouponResponseDTO } from '../models/CouponCommon_Models_DTO_Responses_GetCouponResponseDTO';
import type { CustomerCouponGiftsResponse } from '../models/CustomerCouponGiftsResponse';
import type { Gsoa_Coupons_GetCouponCustomerActivations_response } from '../models/Gsoa_Coupons_GetCouponCustomerActivations_response';
import type { Gsoa_Coupons_GetCustomerCoupons_response } from '../models/Gsoa_Coupons_GetCustomerCoupons_response';
import type { Gsoa_Coupons_SetActivity } from '../models/Gsoa_Coupons_SetActivity';
import type { Gsoa_Coupons_SetActivityBatch } from '../models/Gsoa_Coupons_SetActivityBatch';
import type { Gsoa_Coupons_SetActivityBatch_response } from '../models/Gsoa_Coupons_SetActivityBatch_response';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaCouponsService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaCustomerCouponsIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customerCoupons/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Get all customer's coupons
     * @returns Gsoa_Coupons_GetCustomerCoupons_response OK
     * @throws ApiError
     */
    public static getCustomerCoupons({
        customerId,
        apiVersion = 1,
        filter,
        orderBy,
        page,
        pageSize = 50,
    }: {
        customerId: number,
        apiVersion?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p>
         * <i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * <i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.
         * <i>contains</i> - Value types: checks if attribute contains substring. Case Insensitive. Collection of value types: check if collection contains value. Case sensitive
         * <i>gt</i> - checks if attribute is greater then.
         * <i>gt</i> - checks if attribute is greater then or equal.
         * <i>le</i> - checks if attribute is less than or equal.
         * <i>lt</i> - checks if attribute is less than.
         * </p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * Id:eq 123 </br>
         * Id:in 123 </br>
         * CategoryId:eq 123 </br>
         * CategoryId:in 123 </br>
         * CampaignId:eq Abc </br>
         * CampaignId:in Abc,def,ghi </br>
         * Distributions:contains ab </br>
         * Assignment:eq Abc </br>
         * Assignment:in Abc,def,ghi </br>
         * State:in Abc,def,ghi </br>
         * State:eq Abc </br>
         * ValidFrom:gt 123 </br>
         * ValidFrom:ge 123 </br>
         * ValidFrom:le 123 </br>
         * ValidFrom:lt 123 </br>
         * ValidTo:gt 123 </br>
         * ValidTo:ge 123 </br>
         * ValidTo:le 123 </br>
         * ValidTo:lt 123 </br>
         * VisibleFrom:gt 123 </br>
         * VisibleFrom:ge 123 </br>
         * VisibleFrom:le 123 </br>
         * VisibleFrom:lt 123 </br>
         * VisibleTo:gt 123 </br>
         * VisibleTo:ge 123 </br>
         * VisibleTo:le 123 </br>
         * VisibleTo:lt 123 </br>
         * PrintableFrom:gt 123 </br>
         * PrintableFrom:ge 123 </br>
         * PrintableFrom:le 123 </br>
         * PrintableFrom:lt 123 </br>
         * PrintableTo:gt 123 </br>
         * PrintableTo:ge 123 </br>
         * PrintableTo:le 123 </br>
         * PrintableTo:lt 123 </br>
         * Created:gt 123 </br>
         * Created:ge 123 </br>
         * Created:le 123 </br>
         * Created:lt 123 </br>
         * HouseNumbers:contains ab </br>
         * Used:in 123 </br>
         * Used:eq 123 </br>
         * TimeConstraint:contains ab </br>
         * OriginalRebateIds:contains ab </br>
         * ActionNumber:eq Abc </br>
         * ActionNumber:in Abc,def,ghi </br>
         * OriginalRebateId:eq Abc </br>
         * OriginalRebateId:in Abc,def,ghi </br>
         * Activated:eq Abc </br>
         * CouponCustomerId:eq Abc </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: Id:eq Abc;;Id:in Abc,def,ghi
         * </p>
         */
        filter?: string,
        /**
         * <b>Sorting of response result set</b>
         * <p>
         * <details>
         * <summary><b>Supported orders for sorting:</b></summary>
         * <p>
         * <i>asc</i> - Sort result set in ascending order</br>
         * <i>desc</i> - Sort result set in descending order</br>
         * Default order <i>asc</i> </br>
         * </p>
         * </details>
         * <details>
         * <summary><b>Supported attributes:</b></summary>
         * <p>
         * Id</br>
         * Name </br>
         * EAN </br>
         * ValidTo </br>
         * Priority </br>
         * IsPermanent </br>
         * PersonalPriority </br>
         * ComplexPriority </br>
         * Activated </br>
         * </p>
         * </details>
         * <details>
         * <summary><b>Examples:</b></summary>
         * <p>
         * Id</br>
         * Id asc</br>
         * Id desc</br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. <i>OrderBy</i> at first, following with <i>ThenBy</i>.
         * E.g.: Id asc;;Name asc
         * </p>
         */
        orderBy?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_Coupons_GetCustomerCoupons_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customerCoupons/{customerId}',
            path: {
                'apiVersion': apiVersion,
                'customerId': customerId,
            },
            query: {
                'filter': filter,
                'orderBy': orderBy,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Modify all Customer's coupons activity state.
     * @returns Gsoa_Coupons_SetActivityBatch_response OK
     * @throws ApiError
     */
    public static setCustomerCouponActivityBatch({
        customerId,
        requestBody,
        apiVersion = 1,
    }: {
        customerId: number,
        /**
         * Transformation object
         */
        requestBody: Gsoa_Coupons_SetActivityBatch,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_SetActivityBatch_response> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customerCoupons/{customerId}/coupons/activityBatch',
            path: {
                'apiVersion': apiVersion,
                'customerId': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Endpoint nastaví atribut Activated pro daný kupón na hodnotu předanou v těle požadavku (TRUE / FALSE).
     * @returns Gsoa_Coupons_GetCouponCustomerActivations_response OK
     * @throws ApiError
     */
    public static setCustomerCouponActivity({
        customerId,
        couponId,
        requestBody,
        apiVersion = 1,
    }: {
        customerId: number,
        /**
         * Coupon's identification
         */
        couponId: number,
        /**
         * Coupon's activity request DTO.
         */
        requestBody: Gsoa_Coupons_SetActivity,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_GetCouponCustomerActivations_response> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customerCoupons/{customerId}/coupons/{couponId}/activity',
            path: {
                'apiVersion': apiVersion,
                'customerId': customerId,
                'couponId': couponId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Get all coupon templates.
     * @returns CouponCommon_Models_DTO_Responses_GetAllCouponsResponseDTO OK
     * @throws ApiError
     */
    public static couponsGetAllCoupons({
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        orderBy = '',
    }: {
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b><p><details><summary><b>Supported operators:</b></summary><p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.
         * <i>contains</i> - Value types: checks if attribute contains substring. Case Insensitive. Collection of value types: check if collection contains value. Case sensitive
         * <i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * <i>gt</i> - checks if attribute is greater then.
         * <i>gt</i> - checks if attribute is greater then or equal.
         * <i>le</i> - checks if attribute is less than or equal.
         * <i>lt</i> - checks if attribute is less than.
         * </p></details><details><summary><b>Supported attributes - examples:</b></summary><p>Id:in 123 </br>Name:contains ab </br>EAN:contains ab </br>CategoryId:eq 123 </br>CategoryId:in 123 </br>CampaignId:eq Abc </br>CampaignId:in Abc,def,ghi </br>Distributions:contains ab </br>Assignment:eq Abc </br>Assignment:in Abc,def,ghi </br>State:in Abc,def,ghi </br>State:eq Abc </br>ValidFrom:gt 123 </br>ValidFrom:ge 123 </br>ValidFrom:le 123 </br>ValidFrom:lt 123 </br>ValidTo:gt 123 </br>ValidTo:ge 123 </br>ValidTo:le 123 </br>ValidTo:lt 123 </br>VisibleFrom:gt 123 </br>VisibleFrom:ge 123 </br>VisibleFrom:le 123 </br>VisibleFrom:lt 123 </br>VisibleTo:gt 123 </br>VisibleTo:ge 123 </br>VisibleTo:le 123 </br>VisibleTo:lt 123 </br>PrintableFrom:gt 123 </br>PrintableFrom:ge 123 </br>PrintableFrom:le 123 </br>PrintableFrom:lt 123 </br>PrintableTo:gt 123 </br>PrintableTo:ge 123 </br>PrintableTo:le 123 </br>PrintableTo:lt 123 </br>Created:gt 123 </br>Created:ge 123 </br>Created:le 123 </br>Created:lt 123 </br>HouseNumbers:contains ab </br>TimeConstraint:contains ab </br>OriginalRebateIds:contains ab </br>ActionNumber:eq Abc </br>ActionNumber:in Abc,def,ghi </br>Activated:eq Abc </br></p></details>Combinations possible, concatenation with ";;" means logical AND. E.g.: Id:in Abc,def,ghi;;Name:contains ab </p>
         */
        filter?: string,
        /**
         * <b>Sorting of response result set</b><details><summary><b>Supported orders for sorting:</b></summary><p><i>asc</i> - Sort result set in ascending order</br><i>desc</i> - Sort result set in descending order</br>Default order <i>asc</i> </br></p><p></details><details><summary><b>Supported attributes:</b></summary><p>Id </br>Name </br>EAN </br>ValidTo </br></p></details><details><summary><b>Examples:</b></summary><p>Id</br>Id asc</br>Id desc</br></p></details>Combinations possible, concatenation with ";;" means logical AND. <i>OrderBy</i> at first, following with <i>ThenBy</i>. E.g.: Id asc;;Name asc </p>
         */
        orderBy?: string,
    }): CancelablePromise<CouponCommon_Models_DTO_Responses_GetAllCouponsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/coupons',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'orderBy': orderBy,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Get all coupon templates.
     * @returns CouponCommon_Models_DTO_Responses_GetAllCouponsResponseDTO OK
     * @throws ApiError
     */
    public static couponsGetAllCouponsInformational({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<CouponCommon_Models_DTO_Responses_GetAllCouponsResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/coupons/gifts/informational',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Get all coupon templates.
     * @returns CustomerCouponGiftsResponse OK
     * @throws ApiError
     */
    public static couponsGetAllCouponsCustomer({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<CustomerCouponGiftsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/coupons/gifts/customer',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Get the coupon detail template.
     * @returns CouponCommon_Models_DTO_Responses_GetCouponResponseDTO OK
     * @throws ApiError
     */
    public static couponsGetCoupon({
        couponId,
        apiVersion = 1,
    }: {
        /**
         * The coupon identification
         */
        couponId: number,
        apiVersion?: number,
    }): CancelablePromise<CouponCommon_Models_DTO_Responses_GetCouponResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/coupons/{couponId}',
            path: {
                'apiVersion': apiVersion,
                'couponId': couponId,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
